const setPromiseState = (
  isPending = false,
  isSuccess = false,
  isRejected = false,
) => {
  return {
    isPending,
    isSuccess,
    isRejected,
  };
};

export default setPromiseState;



// WEBPACK FOOTER //
// ./src/app/utils/promiseState.js